import { projects, projectTags } from '../data/landing'
import { projectDetails, type ProjectDetail } from '../data/projectDetails'
import { slugify } from './slug'

export type Project = {
  slug: string
  title: string
  summary: string
  image: string
  tags: string[]
} & ProjectDetail

const emptyDetail: ProjectDetail = {
  client: '',
  location: '',
  year: '',
  services: [],
  challenge: '',
  approach: '',
  outcome: '',
  stats: [],
}

/** Every project merged with its case-study content, in display order. */
export const allProjects: Project[] = projects.map((p) => ({
  ...emptyDetail,
  ...(projectDetails[p.title] ?? {}),
  slug: slugify(p.title),
  title: p.title,
  summary: p.summary,
  image: p.image,
  tags: projectTags[p.title] ?? [p.tag],
}))

export function getProject(slug: string | undefined) {
  return allProjects.find((p) => p.slug === slug)
}
